export const accountsBody = [
  "BrickId",
  "Owner",
  "AllocationProfile",
  "AccountNo",
  "AccountTypeKey",
  "OwnerAccountLabel",
  "Insured",
  "DecisionMakers",
  "Reseller",
  "CustomFields",
  "FirstPaymentAge",
  "FirstPaymentDate",
  "PaymentLength",
  "PayoutsLeft",
];

export const accountDetailsBody = [
  // getAccountTypes
  [
    "BrickId",
    "Key",
    "Label",
    "AccountNoSeriesKey",
    "AccountTypeStatus",
    "AccountPositionLogic",
    "InterestRateInstrumentKey",
    "MustCover",
    "IsSubjectToIncomeTax",
    "IsInsuranceAccount",
    "ExternalHouse",
  ],
  // getAllocationProfiles
  ["BrickId", "Key", "Name", "Owner", "AllocationItems"],
  // positions
  [
    "Account",
    "Asset",
    "BalanceDate",
    "Amount",
    "AcquisitionValue",
    "AcquisitionValueAccountCurrency",
    "Opened",
    "AccountDimensionKey",
    "Price",
    "FxRate",
    "BaseRate",
    "DisplayCurrency",
    "MarketValue",
    "MarketValueAccountCurrency",
    "MarketValueDisplayCurrency",
    "PreviousMarketValue",
    "PreviousMarketValueDisplayCurrency",
    "MarketValueChange",
    "AcquisitionValueAccountCurrency",
    "AcquisitionPrice",
    "AcquisitionPriceAccountCurrency",
    "AcquisitionPriceDisplayCurrency",
    "ReturnValue",
    "ReturnValueAccountCurrency",
    "ReturnValueDisplayCurrency",
    "ReturnPercentage",
    "ReturnPercentageAccountCurrency",
    "ReturnPercentageDisplayCurrency",
    "DisplayRate",
    "ReservedAmount",
    "AvailableAmount",
    "AssetType",
    "Account_AccountNo",
  ],
  // businessTransactions
  [
    "SequenceNo",
    "Account",
    "NameAsset1",
    "NameAsset2",
    "Label",
    "BusinessTransactionTypeKey",
    "AmountAsset1",
    "AmountAsset2",
    "TradeDate",
    "SettlementDate",
    "CreateDate",
    "Price",
    "AcquisitionValue",
    "IsCorrected",
  ],
  // pendingOrders
  [
    "BrickId",
    "Account",
    "ReBalanceInstance",
    "CreatedDate",
    "AllocationItems",
    "OrderNo",
    "CreatedById",
    "State",
  ],
];
